module.exports = __webpack_public_path__ + "static/devteam_01-d065e5d9636cab33cb2b4491a9b4fb88.jpg";